// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const fromJsonString = (str?: string, defaultValue: any = null) => {
  if (!str) return defaultValue
  try {
    return JSON.parse(str)
  } catch (error) {
    return str
  }
}
